import type { Notification } from '../types/notification.type'

export const getUnreadNotificationCount = (notifications: Notification[]): number =>
  notifications.filter((notification) => !notification.isRead).length
